<template>
  <div :style="{ height: OFFSETHEIGHT - 370 + 'px' }">
    <iframe
      v-if="showJLLT"
      :src="page_path"
      style="width: 100%; height: 100%"
      loading="lazy"
      frameborder="0"
      tabindex="0"></iframe>
    <div v-if="!showJLLT" class="noVip">
      <i class="iconfont icon-taocan-suoxiao"></i>
      抱歉，当前内容只能开通此板块的客户查看，请联系管理员开通
      <el-button size="small" class="openBtn">联系管理员开通</el-button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    page_path: String,
  },
  data() {
    return {
      OFFSETHEIGHT: 0,
    };
  },
  computed: {
    ...mapState({
      isLogin: (state) => state.isLogin,
      showJLLT: (state) => {
        const sub_product = state.user_info.sub_product || '';
        return sub_product.indexOf('JLLT') >= 0;
      },
    }),
  },
  mounted() {
    this.fnGetWidth();
  },
  methods: {
    fnGetWidth() {
      this.ROOTFONTFIZE = localStorage.getItem('ROOTFONTFIZE');
      this.TABPANEHEIGHT = localStorage.getItem('TABPANEHEIGHT');
      var element = document.getElementById('rootchart');
      let ROOTFONTFIZE = element.offsetWidth;
      ROOTFONTFIZE = ROOTFONTFIZE > 1440 ? 1440 : ROOTFONTFIZE;
      ROOTFONTFIZE = ROOTFONTFIZE < 1440 ? ROOTFONTFIZE - 200 : ROOTFONTFIZE;
      let OFFSETHEIGHT = element.offsetHeight;
      this.OFFSETHEIGHT = OFFSETHEIGHT;
    },
  },
};
</script>

<style scoped lang="less">
.openBtn {
  background-color: var(--primary-color) !important;
  color: #333333 !important;
  border: none !important;
  margin-top: calc(var(--ROOTFONTFIZE) * (20 / 144));
}
.icon-taocan-suoxiao {
  font-size: calc(var(--ROOTFONTFIZE) * (50 / 144));
  margin-bottom: calc(var(--ROOTFONTFIZE) * (30 / 144));
}
.noVip {
  font-size: calc(var(--ROOTFONTFIZE) * (16 / 144));
  letter-spacing: calc(var(--ROOTFONTFIZE) * (2 / 144));
  color: var(--legndAreaItem_color);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  // height: calc(var(--ROOTFONTFIZE) * (480 / 144));
  height: 100%;
  border-radius: calc(var(--ROOTFONTFIZE) * (20 / 144));
  background-color: var(--charts_bgc);
  // margin: calc(var(--ROOTFONTFIZE) * (20 / 144)) calc(var(--ROOTFONTFIZE) * (30 / 144));
  border: 1px solid var(--charts_bgc);
}
</style>
